"use client";

type ChartLoaderProps = {
  primaryColor?: string;
};

export function ChartLoader({ primaryColor = "#66c0f4" }: ChartLoaderProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-[#16202d] rounded-lg z-10">
      <div className="flex flex-col items-center gap-3">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 border-4 border-[#2a475e] rounded-full"></div>
          <div
            className="absolute inset-0 border-4 border-transparent rounded-full animate-spin"
            style={{ borderTopColor: primaryColor }}
          ></div>
        </div>
        <p className="text-[#8f98a0] text-sm">Loading history...</p>
      </div>
    </div>
  );
}

